import { createStackNavigator } from "@react-navigation/stack"
import React from "react"

import WebReceipt from "./WebReceipt"
import WebReceiptList from "./WebReceiptList"

const Nav = createStackNavigator()
export default () => {
  return (
    <Nav.Navigator>
      <Nav.Screen
        name="Vagabond Receipts"
        component={WebReceipt}
        options={{ headerShown: false }}
      />
      <Nav.Screen
        name="Receipt Results"
        component={WebReceiptList}
        options={{ headerShown: false }}
      />
    </Nav.Navigator>
  )
}

export { WebReceipt }
